module.exports = __webpack_public_path__ + "img/Dahua_Looc_Outdoor.80a6cf3a.png";